export const USER_GREETING_CHAT = 'Hai Bukalapak, saya membutuhkan bantuan.';
export const BEGIN_AGENT_CHAT = 'Hubungkan Dengan CS';
export const USER_ASKS_TO_TYPE_CHAT = 'Saya ingin mengetik masalah saya';
export const USER_ASK_TRANSACTION_PROBLEM = 'Pilih transaksi bermasalah';
export const VP_DID_NOT_RECEIVE_CHAT_OPTIONS = [
  'Pulsa pelanggan belum masuk',
  'Paket data saya belum masuk',
  'Pulsa saya belum masuk',
];
export const CUSTOMER_WAITING_STATE_CHAT_OPTIONS = [
  'Pelanggan masih di warung',
  'Pelanggan sudah pulang',
];

export const CHATBOT_COMMANDS = {
  common: {
    endSession: '[end session]',
  },

  shows: {
    showTextField: '[show] textField [/show]',
    showChangePhoneNumberFormLink: '[show] showChangePhoneNumberFormLink [/show]',
  },

  apicall: {
    checkAutoRefundEligibility: '[apicall] checkAutoRefundEligibility [/apicall]',
    checkKirimUangStatus: '[apicall] checkKirimUangStatus [/apicall]',
    executeRefundMitra: '[apicall] executeRefundMitra [/apicall]',
    checkKirimUangRemittedTime: '[apicall] checkKirimUangRemittedTime [/apicall]',
    checkSaldoWallet: '[apicall] checkSaldoWallet [/apicall]',
    checkInvoiceStatus: '[apicall] checkInvoiceStatus [/apicall]',
    checkBuktiPembayaran: '[apicall] checkBuktiPembayaran [/apicall]',
    checkPaymentBillings: '[apicall] checkPaymentBillings [/apicall]',
    checkUser7DaysGMV: '[apicall] checkUser7DaysGMV [/apicall]',
    checkUserElectricMeter: '[apicall] checkUserElectricMeter [/apicall]',
    checkElectricityPrepaidTrxStatus: '[apicall] checkElectricityPrepaidTrxStatus [/apicall]',
    showUserElectricToken: '[apicall] showUserElectricToken [/apicall]',
    checkCredentialChangeHistory: '[apicall] checkCredentialChangeHistory [/apicall]',
    checkBayarTempoState: '[apicall] checkBayarTempoState [/apicall]',
    checkBayarTempoReapplyDate: '[apicall] checkBayarTempoReapplyDate [/apicall]',
    checkPaidPhoneCreditDuration: '[apicall] checkPaidPhoneCreditDuration [/apicall]',
    showPhoneCreditSerialNumber: '[apicall] showPhoneCreditSerialNumber [/apicall]',
    checkDataPlanPrepaidTrxState: '[apicall] checkDataPlanPrepaidTrxState [/apicall]',
    checkBuktiQRIS: '[apicall] checkBuktiQRIS [/apicall]',
    unstuckDataPlanPrepaidTrx: '[apicall] unstuckDataPlanPrepaidTrx [/apicall]',
    checkWithdrawalStatus: '[apicall] checkWithdrawalStatus [/apicall]',
    checkWithdrawalSLA: '[apicall] checkWithdrawalSLA [/apicall]',
    checkKirimUangSLA: '[apicall] checkKirimUangSLA [/apicall]',
    checkPdamStateAndSLA: '[apicall] checkPdamStateAndSLA [/apicall]',
    checkPostpaidElectricityStateAndSLA: '[apicall] checkPostpaidElectricityStateAndSLA [/apicall]',
    checkDanaTopupStateAndSLA: '[apicall] checkDanaTopupStateAndSLA [/apicall]',
    unstuckTrxAutorefundForProcessed: '[apicall] unstuckTrxAutorefundForProcessed [/apicall]',
    checkTrxStateAutorefundForProcessed: '[apicall] checkTrxStateAutorefundForProcessed [/apicall]',
    executeAutorefundForProcessed: '[apicall] executeAutorefundForProcessed [/apicall]',
    executeAutorefundForSecondaryFailed: '[apicall] executeAutorefundForSecondaryFailed [/apicall]',
  },

  responses: {
    noSelectedTransaction: '[response] noSelectedTransaction [/response]',
    outsideWorkingHours: '[response] outsideWorkingHours [/response]',
  },
};
